import { chooseAOrB } from 'common/helper/choose/a-or-b';

/**
 * Returns defaultValue when aValue is undefined; Returns aValue otherwise
 */
export const chooseAOrDefault = <Value>(aValue: Value, defaultValue: Value): Value =>
  chooseAOrB(aValue, defaultValue)(aValue !== undefined);
